import React from 'react';
import { Grid, Button } from '@mui/material';

export const IssueButtons = ({ onApprove, onDelete, onArchive, onPrevious, onNext }) => {
  return (
    <Grid container justifyContent='space-between' marginBottom='32px'>
      <Grid item>
        <Button
          variant='contained'
          style={{ marginRight: '8px' }}
          onClick={() => {
            onPrevious();
          }}
        >
          Anterior
        </Button>
        <Button variant='contained' onClick={onNext}>
          Próximo
        </Button>
      </Grid>

      <Grid item>
        <Button
          variant='contained'
          style={{ marginRight: '8px', backgroundColor: 'grey', color: 'white' }}
          onClick={onArchive}
        >
          Arquivar
        </Button>
        <Button
          variant='contained'
          style={{ marginRight: '8px', backgroundColor: 'red', color: 'white' }}
          onClick={onDelete}
        >
          Deletar
        </Button>
        <Button variant='contained' style={{ backgroundColor: 'green', color: 'white' }} onClick={onApprove}>
          Resolvido
        </Button>
      </Grid>
    </Grid>
  );
};
